module.exports = __webpack_public_path__ + "img/map-md.b3e0a0fd.jpg";